// extracted by mini-css-extract-plugin
module.exports = {"container":"TokenPortfolioCard_container__2K9cs","logo":"TokenPortfolioCard_logo__1-F6M","name":"TokenPortfolioCard_name__1JsnV","sending":"TokenPortfolioCard_sending__cAAu1"};